export const secondsToMicroseconds = (seconds) => seconds * 1000000;
export const microsecondsToSeconds = (microseconds) => microseconds / 1000000;

export function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

export function convertMillisecondsToMinutesSeconds(milliseconds) {
  const minutes = Math.floor(milliseconds / 60000);
  const seconds = Math.round((milliseconds % 60000) / 1000);

  return seconds === 60
    ? `${padTo2Digits(minutes + 1)}:00`
    : `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
}
export function convertMircosecondsToMinutesSeconds(microseconds) {
  return convertMillisecondsToMinutesSeconds(microseconds / 1000);
}

export const formatTimestamp = (timestamp) => {
  const timeArray = timestamp.split(':');
  timeArray.shift();
  return timeArray.join(':').replace(' ', '');
};

export const microsecondsToTimeStamp = (
  microseconds,
  { includeDecimals } = { includeDecimals: false },
) => {
  const totalSeconds = Math.floor(microseconds / 1000000);
  const microsecondsRemainder = microseconds % 1000000;

  const seconds = totalSeconds % 60;
  const minutes = Math.floor(totalSeconds / 60) % 60;
  const hours = Math.floor(totalSeconds / 3600);

  const formatted = `${String(hours).padStart(2, '0')}:${String(
    minutes,
  ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  if (includeDecimals) {
    const decimal = Math.floor(microsecondsRemainder);
    return `${formatted}.${decimal}`;
  }

  return formatted;
};

export const secondsToTimeStamp = (seconds) =>
  microsecondsToTimeStamp(secondsToMicroseconds(seconds));

export const stripTimemarker = (url) => url?.split('#t=')[0];

export const timestampAsMicroseconds = (timestamp, { includesHours }) => {
  const timeArray = timestamp.split(':');
  const microsecondsInAnHour = 3600000000;
  const microsecondsInAMinute = 60000000;
  const microsecondsInASecond = 1000000;
  if (includesHours) {
    return (
      parseInt(timeArray[0], 10) * microsecondsInAnHour +
      parseInt(timeArray[1], 10) * microsecondsInAMinute +
      parseFloat(timeArray[2], 10) * microsecondsInASecond
    );
  }
  return (
    parseInt(timeArray[0], 10) * microsecondsInAMinute +
    parseFloat(timeArray[1], 10) * microsecondsInASecond
  );
};

export const timeStringToDate = (timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, seconds || 0, 0);
  return date;
};
